import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography, CardActions } from '@material-ui/core';
import MaskedInput from 'react-maskedinput';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import classes from '../Payment.module.scss';
import { checkCreditOrDebit } from '../../../../helpers/PostDataApi';
import config from '../../../../constants/config';
import '../tsepFields.css';
import PropTypes from 'prop-types';
import { Buttons } from '../../../../components/Buttons';
import { setTsepAuth } from '../../../../actions/LocationAction';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TsepCard from '../../../../components/CardForm/TsepCard';

const CardForm = (props) => {
  const [tsepFieldError, setTsepFieldError] = useState('');
  const [cardType, setCardType] = useState(null);
  const [creditOrDebit, setCreditOrDebit] = useState(null);
  const dispatch = useDispatch();
  const [location, setLocation] = useState(null);
  const [gateway, setGateway] = useState('');
  useEffect(() => {
    document.addEventListener('tsepEventUpdate', handleTsepEventUpdated);
    const { location: locationDetails } = props;
    setGateway(locationDetails.gateway);
    if (locationDetails.gateway === 'multipass' && locationDetails.multipassCredentials) {
      setLocation(locationDetails);
    }
  }, [location]);

  useEffect(() => {
    if (props.location && props.location.gateway == 'multipass' && props.location.multipassCredentials) {
      setLocation(props.location);
    }
  }, [props]);
  const { t } = useTranslation();

  const renderLabel = (text, isError) => (
    <label className={classNames(['MuiTypography-gutterBottom', isError ? 'errorCard' : ''])}>{text}</label>
  );

  const renderErrorMessage = (errorMessage) => (
    <label className={classNames(['MuiTypography-gutterBottom', 'errorCard'])}>{errorMessage}</label>
  );
  const renderCardForm = () => {
    if (props.isStoredCard) {
      return (
        <Grid container spacing={3}>
          <Grid item md={8}>
            <div className="block">
              <Card className={classNames(['maskData', 'customCardWraper'])}>
                <div className="Card_header">
                  <Typography variant="h5" component="h2" style={{ textTransform: 'capitalize' }}>
                    Name : {`${props.customerData.firstName} ${props.customerData.lastName}`}
                  </Typography>
                </div>
                <CardContent className="cardContents">
                  <label className="MuiTypography-gutterBottom">{t('maskCardNumber')}</label>
                  <Grid container item xs={12}>
                    {props.customerData.masked_card_number}
                  </Grid>
                </CardContent>
                <CardActions>
                  <Buttons
                    id="AddNewCard"
                    type="button"
                    variant="contained"
                    color="secondary"
                    className={'addNewCardBtn'}
                    onClick={props.handleCard}
                    text={'Add Another Card'}
                  />
                </CardActions>
              </Card>
            </div>
          </Grid>
        </Grid>
      );
    }

    if (gateway === 'multipass') {
      return TsepForm();
    } else if (!props.isStoredCard) {
      return (
        <Grid container spacing={3}>
          <Grid item md={12}>
            {props.error.cardNumberError
              ? renderErrorMessage(t('cardNumberInvalid'))
              : renderLabel(t('cardNumber'), props.error.cardNumberError)}
            <MaskedInput
              type="text"
              value={props.card.cardNumber}
              className={classNames([classes.cardNum, 'pt-encrypt'])}
              mask={props.americanExpress ? '111111111111111' : '1111111111111111'}
              label="Card Number"
              id="cardNumber"
              name="encryptedNumber"
              style={{ minWidth: '100%', paddingLeft: '18px' }}
              size="20"
              onChange={props.handleChangeCard}
            />
          </Grid>
          <Grid item md={4}>
            {props.error.cardExpiryDateError
              ? renderErrorMessage(t('cardExpiryDateInvalid'))
              : renderLabel(t('cardExpiryDate'), props.error.cardExpiryDateError)}
            <MaskedInput
              mask="11/1111"
              className={classes.expDate}
              value={props.card.cardExpiryDate}
              name="cardExpiryDate"
              id="cardExpiryDate"
              placeholder="mm/yyyy"
              ref={props.expiryDateRef}
              onChange={props.handleChangeCard}
            />
          </Grid>
          <Grid item md={2}>
            {props.error.cardCscError
              ? renderErrorMessage(t('cardCscInvalid'))
              : renderLabel(t('cardCsc'), props.error.cardCscError)}
            <MaskedInput
              type="text"
              className={classNames([classes.cardCvv, 'pt-encrypt'])}
              value={props.card.cardCsc}
              mask={props.americanExpress ? '1111' : '111'}
              id="cardCsc"
              name="encryptedCsc"
              ref={props.cscCardRef}
              onChange={props.handleChangeCard}
            />
          </Grid>
        </Grid>
      );
    }
  };

  const TsepForm = () => {
    return (
      <>
        {tsepFieldError && <div className="tsepError">{renderErrorMessage(tsepFieldError)}</div>}
        <TsepCard displayCardDetails={{ variant: 'simple', showCardInput: true }} />
      </>
    );
  };

  const setTsepCardPaymentType = () => {
    const cardNumberElement = document.getElementById('tsep-cardNum');
    if (cardNumberElement) {
      const cardNumberValue = cardNumberElement?.value.replace(/\s/g, '');
      checkCardPaymentType(cardNumberValue);
    }
  };

  const checkCardPaymentType = (cardNumber) => {
    checkCreditOrDebit(config.BIN_CHECKER_URL, config.BIN_API_KEY, cardNumber.substring(0, 6))
      .then((data) => {
        props.setBinCodesResponse(data?.data ? data.data : null);
        props.setPaymentType(data?.data?.type ? data.data.type : null);
        props.setCreditOrDebit(data?.data?.type ? data.data.type : null);
        setCardType(data?.data?.card ? data.data.card : null);
        setCreditOrDebit(data?.data?.type ? data.data.type : null);
      })
      .catch(() => {
        if (creditOrDebit !== null) {
          setCreditOrDebit(null);
        }
      });
  };

  const handleTsepEventUpdated = (event) => {
    const tsepEventDetail = event.detail;
    if (tsepEventDetail.eventType === 'FieldValidationErrorEvent') {
      setTsepFieldError(tsepEventDetail.event.message);
    } else if (tsepEventDetail.eventType === 'FieldValidationSuccessEvent') {
      setTsepFieldError(null);
    } else if (tsepEventDetail.eventType === 'TokenEvent' && tsepEventDetail.event.status === 'PASS') {
      setTsepFieldError(null);
      localStorage.setItem('0', tsepEventDetail.event.tsepToken);
      localStorage.setItem('1', tsepEventDetail.event.cvv2);
      props.setCard({
        isOpen: true,
        cardNumber: tsepEventDetail.event.tsepToken,
        cardExpiryDate: tsepEventDetail.event.expirationDate,
        encryptedNumber: tsepEventDetail.event.tsepToken,
        cardType: cardType ?? tsepEventDetail.event.cardType,
        customerToken: false,
        cardCsc: tsepEventDetail.event.cvv2,
      });
      props.setMaskedCardNumber(tsepEventDetail.event.maskedCardNumber);
      props.disableMultipassSubmit(false);
      // Handle other cases if needed
    } else if (tsepEventDetail.eventType === 'TokenEvent' && tsepEventDetail.event.status === 'FAILURE') {
      setTsepFieldError(tsepEventDetail.event.message);
    } else if (tsepEventDetail.eventType === 'FocusOutEvent' && tsepEventDetail.event.fieldName === 'tsep-cardNum') {
      setTsepCardPaymentType();
    } else if (
      tsepEventDetail.eventType === 'ErrorEvent' &&
      tsepEventDetail.event.status === 'FAIL' &&
      tsepEventDetail.event.responseCode === 'TSEPERR911'
    ) {
      dispatch(setTsepAuth(false));
    }
  };
  return renderCardForm();
};

CardForm.propTypes = {
  location: PropTypes.any,
  disableMultipassSubmit: PropTypes.func,
  setCard: PropTypes.func,
  gateway: PropTypes.any,
  setBinCodesResponse: PropTypes.func,
  setMaskedCardNumber: PropTypes.func,
};
export default CardForm;
